// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__2hhCj","icon":"SortAdornment_icon__1aTdW","up":"SortAdornment_up__1ImGP","down":"SortAdornment_down__1BwTr","active":"SortAdornment_active__2lbiB"};